export const DEPRECATED_LAYERS = [
  'NewRelicPython27', 
  'NewRelicPython36', 
  'NewRelicPython37', 
  'NewRelicNodeJS810', 
  'NewRelicNodeJS10X', 
  'NewRelicNodeJS12X', 
  'NewRelicNodeJS12XARM64', 
  'NewRelicNodeJS14X', 
  'NewRelicNodeJS14XARM64'
];

export const rowVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -20, transition: { duration: 0.2 } }
};
